<template>
  <el-dialog :title="title" :close-on-click-modal="false" :visible="visible" width="600px" :show-close="false">
    <el-form :model="form" ref="ruleForm" :rules="rules" label-width="100px">
      <el-form-item label="门岗" prop="door" v-if="showDoor">
        <el-select
          class="w-96"
          value-key="id"
          v-model="form.door"
          placeholder="请选择基地门岗"
        >
          <el-option
            v-for="item in doors"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门禁卡ID" prop="access_card_code">
        <el-input class="w-96" v-model="form.access_card_code" placeholder="请输入门禁卡ID" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showDoor: {
      type: Boolean,
      default: false
    },
    sendUrl: {
      type: String,
      default: "/api/queue/admin/send_card"
    },
    returnUrl: {
      type: String,
      default: "/api/queue/admin/return_card"
    }
  },
  data() {
    return {
      title: "",
      visible: false,
      form: {
        booking_id: undefined,
        door: undefined,
        access_card_code: undefined
      },
      doors: [],
      rules: {
        door: [{ required: true, message: "请选择门岗", trigger: "change", type: 'object' }],
        access_card_code: [
          { required: true, message: "请输入门禁卡ID", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async onOpen(booking_id, type, door = undefined) {
      this.title = type === 1 ? "发卡确认" : "退卡确认";
      this.form.booking_id = booking_id;
      if (door) {
        this.form.door = door;
      }
      if (type === 2) {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/detail_booking_card",
          data: {
            booking_id
          }
        });
        const { queue } = dataObj.data.data
        this.form.access_card_code = queue.access_card_code;
      }
      this.visible = true;
    },
    onCancel() {
      this.title = "";
      this.form = {
        booking_id: undefined,
        door: undefined,
        access_card_code: ""
      };
      this.visible = false;
    },
    onConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const url =
            this.title === "发卡确认"
              ? this.sendUrl
              : this.returnUrl;
          this.$common
            .http({
              url,
              data: {
                booking_id: this.form.booking_id,
                door_id: this.form.door.id,
                door_name: this.form.door.name,
                access_card_code: this.form.access_card_code
              }
            })
            .then(() => {
              this.$common.pcToastSuccess("操作成功");
              this.onCancel();
              this.$emit("ok");
            });
        }
      });
    },
    getDoors() {
      this.$common
        .http({
          url: "/api/queue/admin/query_door",
          data: {
            page_size: 999,
            state: 1,
            keyword: ""
          }
        })
        .then(res => {
          this.doors = res.data.data.data;
        });
    }
  },
  created() {
    this.getDoors();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px !important;
}
</style>
